'use client';

import { PageFrame, PageColumn } from '@/components/layout/PageFrame';

/**
 * What a route boundary shows when its page throws — in the page frame and the
 * page column, like everything else, so a crash does not also change the shape
 * of the site.
 *
 * Written in the app's own tokens rather than a page's palette: these screens
 * outlive the design they were built beside, and the storefront's boundary
 * spent the light-theme era printing white text on cream over a button whose
 * colour had been deleted.
 */
export function ErrorScreen({ onRetry }: { onRetry: () => void }) {
  return (
    <PageFrame>
      <PageColumn className="items-center text-center">
        <h1 className="sf-masthead [text-wrap:balance]">Something went wrong</h1>
        {/* No line under the heading. It said "please refresh and try again",
            which is the button, verbatim, one line above it. */}
        <button type="button" onClick={onRetry} className="mm-btn sf-cta sf-cta-ink mt-6">
          Try again
        </button>
      </PageColumn>
    </PageFrame>
  );
}
